import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { GlobalModule } from "src/app/global/global.module";
import { AcompanhamentoParcelaDuplicadaMainComponent } from "./acompanhamento-parcela-duplicada-main/acompanhamento-parcela-duplicada-main.component";

@NgModule({
    declarations: [AcompanhamentoParcelaDuplicadaMainComponent],
    imports: [CommonModule, GlobalModule]
})
export class AcompanhamentoParcelaDuplicadaModule { }